import { render, staticRenderFns } from "./LEDTable.vue?vue&type=template&id=449621be&scoped=true&"
import script from "./LEDTable.vue?vue&type=script&lang=js&"
export * from "./LEDTable.vue?vue&type=script&lang=js&"
import style0 from "./LEDTable.vue?vue&type=style&index=0&id=449621be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449621be",
  null
  
)

export default component.exports